<div>
	<div *ngIf="data.length === 0">
		<div class="alert alert-warning text-center">Brak pokoi podrzęnych! Możesz je dodać edytując pokój</div>
	</div>

	<table class="table table-striped" *ngIf="data">
		<tbody>
			<tr *ngFor="let subRoom of data; let index">
				<td class="first">{{ subRoom.roomType.code }}</td>
				<td>{{ subRoom.fee | price }}</td>
				<td>{{ subRoom.roomType.code }} z {{ getRoom }}</td>
				<td>&nbsp;</td>
				<td>&nbsp;</td>
				<td>&nbsp;</td>
				<td>&nbsp;</td>
				<td>&nbsp;</td>
				<td>&nbsp;</td>
				<td>&nbsp;</td>
				<td>&nbsp;</td>
			</tr>
		</tbody>
	</table>
</div>
